import React, { useState } from 'react';
import './Testimonials.css';

const TESTIMONIALS_DATA = [
  {
    id: 1,
    name: 'Maria Silva',
    image: 'https://randomuser.me/api/portraits/women/1.jpg',
    rating: 5,
    text: 'Serviço impecável! A equipe foi atenta, profissional e resolveu meu problema com rapidez. Recomendo!'
  },
  {
    id: 2,
    name: 'João Santos',
    image: 'https://randomuser.me/api/portraits/men/2.jpg',
    rating: 5,
    text: 'Melhor atendimento que já recebi. Explicaram tudo direitinho e o preço foi justo. Voltaria com certeza!'
  },
  {
    id: 3,
    name: 'Ana Costa',
    image: 'https://randomuser.me/api/portraits/women/3.jpg',
    rating: 5,
    text: 'Excelente diagnóstico e execução perfeita. Minha piscina nunca funcionou tão bem. Muito obrigada!'
  },
  {
    id: 4,
    name: 'Carlos Oliveira',
    image: 'https://randomuser.me/api/portraits/men/4.jpg',
    rating: 5,
    text: 'Profissionais competentes e honestos. Sem surpresas, sem taxas escondidas. Perfeito!'
  },
  {
    id: 5,
    name: 'Patricia Gomes',
    image: 'https://randomuser.me/api/portraits/women/5.jpg',
    rating: 5,
    text: 'Resposta rápida no WhatsApp e serviço de qualidade. Exatamente o que a Brilha Piscina promete!'
  }
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % TESTIMONIALS_DATA.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? TESTIMONIALS_DATA.length - 1 : prevIndex - 1
    );
  };

  const renderStars = (rating) => {
    return [...Array(rating)].map((_, i) => (
      <span key={i} className="star">★</span>
    ));
  };

  return (
    <section id="testimonials" className="testimonials">
      <div className="testimonials-container">
        <h2>Avaliações de Clientes Satisfeitos</h2>
        
        <div className="carousel">
          <div className="carousel-content">
            <div className="testimonial-text">
              <div className="stars">
                {renderStars(TESTIMONIALS_DATA[currentIndex].rating)}
              </div>
              <p className="testimonial-quote">
                "{TESTIMONIALS_DATA[currentIndex].text}"
              </p>
              <p className="testimonial-name">
                — {TESTIMONIALS_DATA[currentIndex].name}
              </p>
            </div>
          </div>

          <button className="carousel-btn prev" onClick={prevSlide}>
            ‹
          </button>
          <button className="carousel-btn next" onClick={nextSlide}>
            ›
          </button>
        </div>

        <div className="carousel-indicators">
          {TESTIMONIALS_DATA.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
